import React, { useState } from 'react';
import * as R from 'ramda';

export default function Chips({
    value,
    onChange,
    label,
    disabled,
    placeholder,
    type,
    rightIcon,
    leftIcon,
    name,
    error: _error,
}: {
    value?: string[];
    onChange?: (value: string[]) => void;
    label?: string;
    disabled?: boolean;
    placeholder?: string;
    type?: 'text' | 'email' | 'number' | 'password';
    rightIcon?: React.ReactNode;
    leftIcon?: React.ReactNode;
    name?: string;
    error?: string | undefined | boolean;
}) {
    const [dirty, setDirty] = useState(false);
    const [text, setText] = useState('');

    const error = dirty && _error;

    function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === 'Enter' && text && !value?.includes(text)) {
            if (onChange) onChange([...(value || []), text]);
            setText('');
        }
    }

    function onChipClose(v: string) {
        if (onChange) onChange(R.without([v], value || []));
    }

    return (
        <label htmlFor={name}>
            {label && <div className="text-sm font-medium pb-1.5 text-label">{label}</div>}
            <div className="relative">
                {!disabled && (
                    <input
                        name={name}
                        disabled={disabled}
                        value={text}
                        type={type}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => {
                            setText(e.target.value);
                            setDirty(true);
                        }}
                        onBlur={() => {
                            setDirty(true);
                        }}
                        placeholder={placeholder || 'Press Enter to add'}
                        className="border rounded-lg text-sm w-full py-2 px-3 transition-colors bg-surface-muted text-foreground placeholder-foreground-muted border-border focus:outline-none focus:bg-surface focus:border-border-strong"
                    />
                )}
                {leftIcon && (
                    <div className="absolute left-0 top-0 bottom-0 flex items-center pl-3 text-foreground-muted pointer-events-none">
                        {leftIcon}
                    </div>
                )}
                {rightIcon && (
                    <div className="absolute right-0 top-0 bottom-0 flex items-center pr-3 text-foreground-muted">
                        {rightIcon}
                    </div>
                )}
            </div>
            {value && value.length > 0 && (
                <div className="flex items-center flex-wrap -mx-1">
                    {value.map((v, i) => (
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                            key={i}
                            className="px-2 py-1 rounded-md text-xs bg-surface-muted border border-border text-foreground flex items-center mx-1 mt-2"
                        >
                            {v}
                            {!disabled && (
                                <button
                                    className="font-bold h-4 w-4 ml-1.5 flex items-center justify-center text-foreground-muted hover:text-foreground hover:bg-border-subtle rounded-full cursor-pointer transition-colors"
                                    type="button"
                                    onClick={() => onChipClose(v)}
                                >
                                    x
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
            {error && <div className="mt-1 text-xs text-danger">{error}</div>}
        </label>
    );
}
